import React, { useState } from 'react';
import { CreateJobDialog } from '../create-job-dialog';
import {
    truncateOrDropChainJobDefaults,
    TruncateOrDropChainJobFormInputs,
    TruncateOrDropChainJobSchema,
} from '../../../../pages/job-manager/job-manager-helper';
import { useForm } from 'react-hook-form';
import { ConfirmationModal } from '../../../../components';
import InvalidPermissionsDialog from '../../../../components/invalid-permissions-dialog/InvalidPermissionsDialog';
import { useNavigate } from 'react-router-dom';
import { useAuth, usePermission } from '../../../../core';
import { yupResolver } from '@hookform/resolvers/yup';
import { JOB_MANAGER_PATHS } from '../../../../constants/job-manager-paths';
import { useDropChain } from '../../../../hooks';
import { TruncateOrDropChainSelectField } from '../truncate-or-drop-chain-select-field/TruncateOrDropChainSelectField';
import {
    confirmationInputLabelText,
    confirmationSubHeadingText,
} from '../truncate-or-drop-chain-select-field/TruncatedChainHeading-helper';

export const CreateDropChain = (): React.JSX.Element => {
    const { mutate: dropChain } = useDropChain();
    const navigate = useNavigate();
    const { hasPermissions } = usePermission();
    const { getToken } = useAuth();
    const {
        handleSubmit,
        control,
        formState: { errors },
        getValues,
    } = useForm<TruncateOrDropChainJobFormInputs>({
        mode: 'all',
        resolver: yupResolver(TruncateOrDropChainJobSchema),
        defaultValues: truncateOrDropChainJobDefaults,
    });
    const [confirmationModalOpen, setConfirmationModalOpen] =
        useState<boolean>(false);
    const [displayPermissionDialog, setDisplayPermissionDialog] =
        useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const openDropChainModal = (): void => {
        setConfirmationModalOpen(true);
    };

    const closeDropChainModal = (): void => {
        setConfirmationModalOpen(false);
    };

    const handleDropChainJob = (): void => {
        setIsLoading(true);
        setTimeout(() => {
            navigate(JOB_MANAGER_PATHS.LANDING_PAGE);
        }, 500);
        dropChain(
            {
                token: getToken(),
                chain: getValues().chain,
            },
            {
                onSuccess: () => {
                    setIsLoading(false);
                },
                onError: () => {
                    setIsLoading(false);
                },
            }
        );
    };

    const onSubmit = (): void => {
        const permission = hasPermissions(['createData', 'createMetadata']);
        if (permission) {
            handleSubmit(openDropChainModal)();
        } else {
            setDisplayPermissionDialog(true);
        }
    };

    const handlePermissionDialogClose = (): void => {
        setDisplayPermissionDialog(false);
    };

    return (
        <CreateJobDialog
            handleSubmit={onSubmit}
            buttonText='DROP Chain'
            isLoading={isLoading}
        >
            <TruncateOrDropChainSelectField control={control} errors={errors} />
            {confirmationModalOpen && (
                <ConfirmationModal
                    confirmationModal={confirmationModalOpen}
                    handleConfirmationModal={closeDropChainModal}
                    confirmationKey={getValues().chain}
                    confirmationButtonText={'Drop Chain'}
                    confirmationHeadingText={'Confirm Chain Drop'}
                    isRequiredIconVisible={false}
                    confirmationInputLabelText={confirmationInputLabelText(
                        getValues().chain,
                        45
                    )}
                    handleConfirmation={handleDropChainJob}
                    confirmationSubHeadingText={confirmationSubHeadingText(
                        getValues().chain,
                        64
                    )}
                />
            )}
            {displayPermissionDialog && (
                <InvalidPermissionsDialog
                    open={displayPermissionDialog}
                    onClose={handlePermissionDialogClose}
                />
            )}
        </CreateJobDialog>
    );
};
